/**
 * Loading and processing message constants
 */

export const MessageDisplayTime = 5000 // 5 seconds

export const CustomerMatchMessages = ['Looking you up... hang tight!', 'Still searching... almost there!']

export const CustomerVerifyMessages = ['Verifying info... one sec!', 'Double-checking... thanks for waiting!']

export const ActionMessages = [
  [], // Index 0: No action
  ['Processing cancellation...', 'Finalizing... almost there!'], // Index 1: Cancel
  ['Processing return...', 'Finalizing return... hang tight!'], // Index 2: Return
  ['Setting up exchange...', 'Confirming details... one sec!'], // Index 3: Exchange
  ['Applying your offer...', 'Locking it in... hang on!'], // Index 4: Offer
  ['Updating order...', 'Making changes... almost there!'], // Index 5: Update
  ['Applying discount...', 'Updating subscription... done soon!'], // Index 6: Discount
  ['Upgrading order...', 'Adding upgrade... hold on!'], // Index 7: Upgrade
  ['Adjusting subscription...', 'Updating plan... one sec!'], // Index 8: Subscription
  ['Processing refund & update...', 'Finalizing changes...'], // Index 9: Refund
  ['Canceling... hold on!', 'Wrapping up... almost done!'], // Index 10: Cancel subscription
  ['Applying your offer...', 'Locking it in... hang on!'], // Index 11: Special offer
  ['Pausing... one moment!', 'Hold in place... almost done!'], // Index 12: Pause
  ['Finalizing purchase...', 'Processing... hang on!'], // Index 13: Purchase
  ['Processing payment...', 'Confirming... one sec!'], // Index 14: Payment
  ['Extending return...', 'Updating eligibility...'], // Index 15: Extend return
  ['Updating details...', 'Finalizing changes...'], // Index 16: Update details
  ['Reactivating...', 'Bringing it back...'], // Index 17: Reactivate
  ['Checking your request...', 'Reviewing... hang tight!'], // Index 18: Review
  ['Updating address...', 'Saving... almost there!'], // Index 19: Address
  ['Saving payment info...', 'Securing details...'], // Index 20: Payment info
  ['Fetching tracking...', 'Locating package...'], // Index 21: Tracking
  ['Creating return label...', 'Generating... hold tight!'], // Index 22: Return label
  ['Extending trial...', 'Updating... almost done!'], // Index 23: Extend trial
]

// Action types enum for type safety
export enum ProcessingAction {
  None = 0,
  Cancel = 1,
  Return = 2,
  Exchange = 3,
  Offer = 4,
  Update = 5,
  Discount = 6,
  Upgrade = 7,
  Subscription = 8,
  Refund = 9,
  CancelSubscription = 10,
  SpecialOffer = 11,
  Pause = 12,
  Purchase = 13,
  Payment = 14,
  ExtendReturn = 15,
  UpdateDetails = 16,
  Reactivate = 17,
  Review = 18,
  Address = 19,
  PaymentInfo = 20,
  Tracking = 21,
  ReturnLabel = 22,
  ExtendTrial = 23,
}

/**
 * Get processing messages for a specific action
 */
export function getActionMessages(action: ProcessingAction): string[] {
  return ActionMessages[action] || []
}

/**
 * Get multiple action messages combined
 */
export function getCombinedActionMessages(actions: ProcessingAction[]): string[] {
  return actions.reduce((messages, action) => {
    return messages.concat(getActionMessages(action))
  }, [] as string[])
}
